// pages/Upload.jsx
import { useState } from "react";
import UploadForm from "../components/UploadForm";
import VideoList from "../components/VideoList";

const Upload = () => {
  const [videos, setVideos] = useState([]);

  const handleUploadSuccess = (newVideo) => {
    setVideos([newVideo, ...videos]); // prepend new video
  };

  return (
    <div className="px-20 py-10">
      <div className="py-5">
        <UploadForm onUploadSuccess={handleUploadSuccess} />
      </div>
      
    </div>
  );
};
export default Upload;
